// pages/vendor/Support.jsx
import React from 'react';
import VendorSupportPage from '../../components/vendor/VendorSupportPage';

const Support = () => {
  return <VendorSupportPage />;
};

export default Support;